var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TwinMatter'),_c('Service'),_c('TradeMark'),_c('AttestationComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }